<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  loadingText="Loading..."
  type="ball-scale-multiple"
></ngx-spinner>
<app-header></app-header>
<div #prefecturePage class="container-fluid">
  <div class="row">
    <div class="col-lg-10 col-md-6">
      <div class="prefectureHeading">
        {{ "Prefectures Information" | translate }}
      </div>
    </div>
    <div class="col-lg-2 col-md-6 downloadTemplate">
      <div class="addPrefectureInfo">
        <button
          class="btn btn-dark"
          style="float: right"
          (click)="openAddPrefecture()"
        >
          {{ "Add Prefecture" | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="prefectureTable">
    <mat-form-field style="width: 100%;">
      <mat-label>Search</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Enter Search Value" #input>
    </mat-form-field>
    <div class="example-container mat-elevation-z8">
     
      <mat-table
        matColumnDef="prefectures"
        [dataSource]="dataSource"
        matSort
        (matSortChange)="sortData($event)"
        *ngIf="length !== 0"
      >
       
        <ng-container matColumnDef="prefecture">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Prefecture" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.prefecture }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cityName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "PrefectureJP" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.prefecturesJP }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="region">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Region" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.region }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef>{{
            "Edit" | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon (click)="editPrefecture(element)" class="edit"
              >edit</mat-icon
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="delete">
          <mat-header-cell *matHeaderCellDef>{{
            "Delete" | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon (click)="deletePrefecture(element)" class="delete"
              >delete</mat-icon
            >
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
         <td class="mat-cell" colspan="4">No data matching the Search Value :  "{{input.value}}"</td>
       </tr>
      </mat-table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                 showFirstLastButtons
                 aria-label="Select page of periodic elements">
      </mat-paginator>
      <div class="noRecord" *ngIf="length === 0">
        <span>{{ "No Records Found" | translate }} </span>
      </div>
     
    </div>
  </div>
</div>
